export const SCROLL_CONFIG = {
    duration: 1000,
    defaultHeaderHeight: 80,
};
